var _path, _path2, _circle, _path3, _ellipse, _path4, _path5, _path6, _path7, _circle2, _ellipse2, _path8, _path9, _path10, _path11, _circle3, _rect, _rect2, _rect3, _rect4, _circle4, _circle5, _rect5, _ellipse3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 206,
    viewBox: "0 0 192 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171.759 104C171.759 138.794 141.538 167 104.259 167C66.9796 167 36.7588 138.794 36.7588 104C36.7588 69.2061 66.9796 41 104.259 41C141.538 41 171.759 69.2061 171.759 104Z",
    fill: "url(#paint0_linear_1645_1639)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7588 27H108.759V43H98.7588V27Z",
    fill: "url(#paint1_linear_1645_1639)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 103.759,
    cy: 15,
    r: 14,
    fill: "#000F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.759 172C144.523 172 176.759 142.003 176.759 105C176.759 82.6269 164.974 62.8153 146.867 50.6465C145.185 49.5166 143.187 48.9736 141.161 48.9736H68.3566C66.3308 48.9736 64.3322 49.5166 62.6508 50.6465C44.5431 62.8153 32.7588 82.6269 32.7588 105C32.7588 142.003 64.9943 172 104.759 172Z",
    fill: "url(#paint2_linear_1645_1639)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.5209,
    cy: 147.972,
    rx: 5.29423,
    ry: 9.92668,
    transform: "rotate(-44.9872 53.5209 147.972)",
    fill: "#236DC1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.618 157.846C67.3312 155.093 65.0658 148.461 59.5579 143.034C54.0501 137.608 47.3856 135.441 44.6723 138.195C41.959 140.949 44.2245 147.581 49.7323 153.007C55.2402 158.434 61.9047 160.6 64.618 157.846ZM59.8861 154.316C61.6126 152.563 60.1711 148.344 56.6665 144.891C53.1619 141.438 48.9213 140.059 47.1949 141.812C45.4685 143.564 46.91 147.784 50.4146 151.237C53.9191 154.689 58.1597 156.068 59.8861 154.316Z",
    fill: "#468BDC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.716 150.302L60.8088 146.373L52.9514 140.187L49.8586 144.116L57.716 150.302ZM41 155.5L41.9806 160.403L41 155.5ZM30.4224 144.876C29.1339 142.434 26.1095 141.498 23.6671 142.787C21.2247 144.075 20.2892 147.099 21.5776 149.542L30.4224 144.876ZM49.8586 144.116C47.1125 147.604 45.098 148.99 43.8262 149.611C42.4705 150.272 41.7997 150.241 40.0194 150.597L41.9806 160.403C42.7003 160.259 45.3398 159.999 48.2111 158.598C51.1664 157.156 54.2955 154.647 57.716 150.302L49.8586 144.116ZM40.0194 150.597C40.2702 150.547 39.9334 150.653 38.7692 150.292C37.7477 149.975 36.5104 149.43 35.2383 148.713C33.9727 148 32.7967 147.187 31.8773 146.405C31.4203 146.017 31.063 145.666 30.8025 145.372C30.6741 145.227 30.5803 145.108 30.5148 145.017C30.4826 144.972 30.4595 144.937 30.444 144.912C30.4283 144.887 30.422 144.875 30.4224 144.876L21.5776 149.542C22.5094 151.308 24.0034 152.836 25.3982 154.022C26.868 155.273 28.5839 156.442 30.3296 157.426C32.0689 158.406 33.9622 159.271 35.8073 159.843C37.5096 160.371 39.7751 160.844 41.9806 160.403L40.0194 150.597Z",
    fill: "#000F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6782 150.349L60.818 146.457L53.0357 140.178L49.8958 144.069L57.6782 150.349ZM44 155L42.2913 150.301L44 155ZM31.1154 143.077C30.0533 140.528 27.1259 139.323 24.5769 140.385C22.0279 141.447 20.8225 144.374 21.8846 146.923L31.1154 143.077ZM21.8846 146.923C22.1383 147.532 22.4307 148.119 22.7508 148.682L31.4427 143.737C31.306 143.497 31.1983 143.276 31.1154 143.077L21.8846 146.923ZM43.3792 160.272C44.1516 160.165 44.9345 159.98 45.7087 159.699L42.2913 150.301C42.2357 150.321 42.1433 150.348 42.0043 150.367L43.3792 160.272ZM45.7087 159.699C45.9542 159.61 46.1824 159.529 46.3951 159.456L43.1415 150C42.8754 150.092 42.5926 150.191 42.2913 150.301L45.7087 159.699ZM57.1775 150.971C57.3379 150.771 57.5047 150.564 57.6782 150.349L49.8958 144.069C49.7163 144.291 49.5438 144.506 49.3779 144.712L57.1775 150.971Z",
    fill: "#0F4688"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2076 149.209C63.1456 147.155 61.5676 145.014 59.5579 143.034C56.4413 139.964 52.9543 137.937 50.0224 137.255L51.2595 141.398C52.9746 141.955 54.9127 143.163 56.6665 144.891C58.0727 146.276 59.1468 147.785 59.8173 149.209H64.2076Z",
    fill: "#468BDC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5557,
    cy: 138.555,
    r: 10.625,
    transform: "rotate(-30.6263 22.5557 138.555)",
    fill: "#85B7F2"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.29423,
    cy: 9.92668,
    rx: 5.29423,
    ry: 9.92668,
    transform: "matrix(-0.707265 -0.706949 -0.706949 0.707265 165.765 144.694)",
    fill: "#236DC1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.906 157.846C141.193 155.093 143.459 148.461 148.966 143.034C154.474 137.608 161.139 135.441 163.852 138.195C166.565 140.949 164.3 147.581 158.792 153.007C153.284 158.434 146.62 160.6 143.906 157.846ZM148.638 154.316C146.912 152.563 148.353 148.344 151.858 144.891C155.363 141.438 159.603 140.059 161.33 141.812C163.056 143.564 161.614 147.784 158.11 151.237C154.605 154.689 150.365 156.068 148.638 154.316Z",
    fill: "#468BDC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M150.808 150.302L147.715 146.373L155.572 140.187L158.665 144.116L150.808 150.302ZM169.5 162.709L173.974 160.475L169.5 162.709ZM163.857 177.351C161.293 178.377 158.383 177.13 157.358 174.566C156.332 172.002 157.579 169.092 160.143 168.067L163.857 177.351ZM158.665 144.116C161.386 147.573 163.939 149.64 166.53 151.823C169.086 153.978 171.972 156.466 173.974 160.475L165.027 164.943C164.033 162.951 162.62 161.606 160.085 159.469C157.584 157.361 154.253 154.679 150.808 150.302L158.665 144.116ZM173.974 160.475C175.265 163.062 175.731 165.804 174.957 168.475C174.209 171.056 172.519 172.818 170.999 173.959C168.294 175.988 164.289 177.178 163.857 177.351L160.143 168.067C160.579 167.892 161.123 167.704 161.519 167.564C161.972 167.405 162.415 167.245 162.861 167.067C163.79 166.695 164.511 166.325 164.998 165.959C165.478 165.6 165.412 165.486 165.352 165.693C165.266 165.989 165.483 165.856 165.027 164.943L173.974 160.475Z",
    fill: "#000F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M150.808 150.302L147.715 146.373L155.572 140.187L158.665 144.116L150.808 150.302ZM168.5 161L172.973 158.766L168.5 161ZM163.506 177.477C160.873 178.308 158.064 176.848 157.232 174.215C156.401 171.581 157.861 168.773 160.495 167.941L163.506 177.477ZM160.495 167.941C160.812 167.841 161.113 167.742 161.4 167.645L164.606 177.117C164.25 177.238 163.883 177.358 163.506 177.477L160.495 167.941ZM164.434 164.073C164.311 163.81 164.176 163.532 164.027 163.235L172.973 158.766C173.15 159.12 173.322 159.473 173.487 159.824L164.434 164.073ZM164.027 163.235C163.895 162.97 163.763 162.732 163.632 162.514L172.186 157.336C172.462 157.791 172.724 158.267 172.973 158.766L164.027 163.235ZM151.683 151.379C151.393 151.033 151.101 150.675 150.808 150.302L158.665 144.116C158.895 144.408 159.121 144.686 159.343 144.95L151.683 151.379Z",
    fill: "#0F4688"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.317 149.209C145.379 147.155 146.957 145.014 148.966 143.034C152.083 139.964 155.57 137.937 158.502 137.255L157.265 141.398C155.55 141.955 153.612 143.163 151.858 144.891C150.452 146.276 149.378 147.785 148.707 149.209H144.317Z",
    fill: "#468BDC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.556,
    cy: 176.555,
    r: 10.625,
    transform: "rotate(-30.6263 157.556 176.555)",
    fill: "#86B8F3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 147,
    width: 1.5,
    height: 10.5,
    rx: 0.75,
    fill: "#5998E1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 147,
    width: 1.5,
    height: 10.5,
    rx: 0.75,
    fill: "#5998E1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 90.5,
    y: 144,
    width: 1.5,
    height: 18,
    rx: 0.75,
    fill: "#5998E1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 67,
    width: 116,
    height: 61,
    rx: 30.5,
    fill: "#000F20",
    stroke: "#458DDE",
    strokeWidth: 4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 105.5,
    r: 8.5,
    fill: "#72B2FF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.5,
    cy: 105.5,
    r: 8.5,
    fill: "#72B2FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 22.9248,
    height: 44.6151,
    rx: 3.77174,
    transform: "matrix(0.953625 -0.332331 0.347329 0.926932 -0.125 99.9658)",
    fill: "#F06F6F"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.0776,
    cy: 2.05775,
    rx: 2.0776,
    ry: 2.05775,
    transform: "matrix(0.805689 -0.592339 0.620141 0.78449 15.8643 98.4199)",
    fill: "#E33333"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1645_1639",
    x1: 104.259,
    y1: 27,
    x2: 104.259,
    y2: 167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1645_1639",
    x1: 104.259,
    y1: 27,
    x2: 104.259,
    y2: 167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1645_1639",
    x1: 104.759,
    y1: 37.9999,
    x2: 104.759,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83B5F1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedPhone);
export default __webpack_public_path__ + "static/media/red_phone.73844afa6bc1abe1ffd35b1332134f71.svg";
export { ForwardRef as ReactComponent };